import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AmityServiceAxios } from "@configs/api/AmityServiceAxios";

export const useLineAccessToken = (
  options?: UseMutationOptions<
    {
      user_id: string;
      access_token: string;
    },
    {
      message: string;
    },
    {
      codeVerifier: string;
      authorizeCode: string;
    },
    unknown
  >
) => {
  return useMutation({
    mutationFn: async ({ codeVerifier, authorizeCode }) => {
      return await AmityServiceAxios.post("/line-access-token", {
        codeVerifier: codeVerifier,
        authorizeCode: authorizeCode,
      });
    },
    ...options,
  });
};

export const useTriggerRichMenu = (
  options?: UseMutationOptions<
    {
      message: string;
    },
    {
      message: string;
    },
    {
      userId: string;
      isTrigger?: boolean;
    },
    unknown
  >
) => {
  return useMutation({
    mutationFn: async ({ userId, isTrigger }) => {
      return await AmityServiceAxios.post("/trigger-rich-menu", {
        userId: userId,
        isTrigger: isTrigger,
      });
    },
    ...options,
  });
};
